module.exports = __webpack_public_path__ + "assets/img/00022.9bf2ca02.png";